import { ACCESS_ROLES } from '@/constants/permissions';
import type { SubscriptionsTrials } from '@/types/mercury-data-types';
import type { ClientId, UserId } from '@/types/api';

interface Quoins {
  purchased: number;
  spent: number;
  available: number;
}

type RelevantContext = {
  id: number;
  name: string;
  parents: Array<RelevantContext> | null;
  children: Array<RelevantContext> | null;
};

export interface UserInfo {
  entitlements_trial: Array<SubscriptionsTrials>;
  external_auth: number;
  phone: string;
  twofa_activated: boolean;
  quoins: Quoins;
  technologies: Record<string, string>;
  industry_sectors: Record<string, string>;
  locations: Record<string, string>;
  relevant_technologies: Array<RelevantContext>;
  relevant_industry_sectors: Array<RelevantContext>;
  relevant_locations: Array<RelevantContext>;
}

export interface TokenInfo {
  sub: string;
  exp: number;
  user_id: UserId;
  entitlements: Array<string>;
  client_access_id: ClientId;
  client_name: string;
  first_name: string;
  last_name: string;
  role: (typeof ACCESS_ROLES)[keyof typeof ACCESS_ROLES];
  force_2fa: boolean;
  enabled_2fa: boolean;
  jti: string;
  subclients: Record<number, string>;
  is_subclient: boolean;
}

export type LoginFormFields = {
  username: string;
  password: string;
  code: string;
  remember_me: boolean;
};

export const LoginFormLabels = {
  username: 'Email Address',
  password: 'Password',
  code: '2FA Code',
} as const;

export type RegisterFormFields = {
  email: string;
  firstname: string;
  lastname: string;
  client_name: string;
  password?: string;
  confirm_password?: string;
};

export const RegisterFormLabels = {
  email: 'Email',
  firstname: 'First Name',
  lastname: 'Last Name',
  client_name: 'Client',
  password: 'Password',
  confirm_password: 'Confirm Password',
} as const;

export type ResetPasswordFields = {
  password: string;
  new_password: string;
};

export const ResetPasswordLabels = {
  password: 'New Password',
  new_password: 'Retype new Password',
} as const;

export type ForgotPasswordFields = {
  email: string;
};

export const ForgotPasswordLabels = {
  email: 'Email Address',
} as const;

export interface PrecheckReturn {
  username: string;
  auth_type: 'NORMAL' | '2FA' | 'SAML';
}

export interface SAMLResponse {
  redirect_url: string;
}
